import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Simple toast notification component
// In a real app, you'd use a more robust solution like react-hot-toast

export const Toaster: React.FC = () => {
  return (
    <div className="fixed top-4 right-4 z-50">
      <AnimatePresence>
        {/* Toast notifications would appear here */}
      </AnimatePresence>
    </div>
  );
};